// extracted by mini-css-extract-plugin
module.exports = {"input":"textarea_input__28nIQ","label":"textarea_label__2uqGm","alert":"textarea_alert__3zTPQ"};